import data from './data'
import methods from './methods'

export default {
  data,
  methods,

  /* route API for professional address */
  resourcePath: '/v1/professional/companies/addresses'
}



// WEBPACK FOOTER //
// ./src/app/professional/company/addresses/resources/index.js